import { SelectInput as AntdSelectInput } from "@empglabs/backoffice-ui-kit"

const SelectInput = props => {
  return <AntdSelectInput {...props} />
}

export default SelectInput
